export type ProposalStatus = "Submitted" | "Re-Submitted" | "Approved" | "Rejected";

export type ProposalLineItem = {
    serviceId: string | number;
    serviceName: string;
    description: string;
    unitPrice: string;
    quantity: string;
    lineTotal: string;
};

export type Proposal = {
    id: number | null;
    pdfId: string;
    proposalNumber: string;
    proposalDate: string;
    projectId: number | null;
    projectName: string;
    requesterId: string;
    requesterName: string;
    requester: {
        label: string;
        value: string;
    } | null;
    approverId: string;
    approverName: string;
    approver: {
        label: string;
        value: string;
    } | null;
    department: string;
    notes: string;
    subtotal: string;
    tax: string;
    discount: string;
    total: string;
    data: ProposalLineItem[];
    status: ProposalStatus;
    approverNotes: string;
    approvalTime: string;
    submitterId: string;
    submitterName: string;
    submitTime: string;
    notifiedAt: string;
    notifiedBy: string;
    notifierName: string;
    creatorId: string;
    creatorName: string;
    createdAt: string;
    updaterId: string;
    updaterName: string;
    updatedAt: string;
    void: "yes" | "no";
    voidReason: string;
    validateReason: string;
};

export const defaultProposalLineItem: ProposalLineItem = {
    serviceId: "",
    serviceName: "",
    description: "",
    unitPrice: "",
    quantity: "1",
    lineTotal: "",
};

export const defaultProposal: Proposal = {
    id: null,
    pdfId: "",
    proposalNumber: "",
    proposalDate: "",
    projectId: null,
    projectName: "",
    requesterId: "",
    requesterName: "",
    requester: null,
    approverId: "",
    approverName: "",
    approver: null,
    department: "",
    notes: "",
    subtotal: "0.00",
    tax: "0.00",
    discount: "0.00",
    total: "0.00",
    data: [{ ...defaultProposalLineItem }],
    status: "Submitted",
    approverNotes: "",
    approvalTime: "",
    submitterId: "",
    submitterName: "",
    submitTime: "",
    notifiedAt: "",
    notifiedBy: "",
    notifierName: "",
    creatorId: "",
    creatorName: "",
    createdAt: "",
    updaterId: "",
    updaterName: "",
    updatedAt: "",
    void: "no",
    voidReason: "",
    validateReason: "",
};
